const config = {
    branding: {
        productName: 'TakeShape',
        appUrlBase: 'https://app.takeshape.io',
        logotype: 'https://s3.amazonaws.com/takeshape.dev.branding/takeshape-logotype-padded.svg',
        logo: 'https://s3.amazonaws.com/takeshape.dev.branding/takeshape-logo.svg',
        supportEmail: 'support@takeshape.io',
        linkSlack: 'https://join.slack.com/t/takeshapeio/shared_invite/enQtODIwMjExODUxMjcwLWZjYmYyNjJhNjE0MTg2YWI4MjE5ZTU5YTE0YmFlNjViYTlmOGJkYWI2Mjc4YTRiMTViMDE5NThhZGEyYTk2ZjE',
        linkTerms: 'https://www.takeshape.io/legal/terms-and-conditions/',
        linkPrivacy: 'https://www.takeshape.io/legal/privacy-policy/',
        linkStarterProjects: 'https://www.takeshape.io/starters/',
        linkCli: 'https://www.npmjs.com/package/@takeshape/cli',
        linkVscode: '',
        linkStatus: 'https://status.takeshape.io/',
        linkTwitter: 'https://twitter.com/takeshapeio',
        linkIndexingDocs: '',
        linkShopifyStarter: 'https://github.com/takeshape/takeshape-starter-shopify-api-indexing#readme'
    }
};
export const { branding } = config;
